export const generateToolResults = (toolId, context, currentCoachingType, frameworks = []) => {
  const safe = (val) => Array.isArray(val) ? val[0] : val;

  // All frameworks are now dynamic and handled by the backend
  // This function is kept for backwards compatibility but returns generic guidance
  
  // Health/Fitness tools (still supported as they're not framework-based)
  if (currentCoachingType === 'health') {
    if (toolId === 'program') {
      const currentWeight = parseFloat(String(safe(context.current_weight) || safe(context.weight) || '').replace(/[^0-9.]/g, '')) || null;
      const goalWeight = parseFloat(String(safe(context.goal_weight) || '').replace(/[^0-9.]/g, '')) || null;
      const weeklyLoss = currentWeight && goalWeight ? (Math.abs(currentWeight - goalWeight) <= 20 ? 1 : 1.5) : 1;
      const timeline = (currentWeight && goalWeight) ? Math.ceil(Math.abs(currentWeight - goalWeight) / weeklyLoss) : 12;
      const summary = currentWeight && goalWeight
        ? `We can target about ${weeklyLoss}/lb per week - that puts you at roughly ${timeline} weeks. Let's start with 3 short full-body sessions and a daily walk.`
        : `Let's get you moving with 3 short full-body sessions and a daily walk. We'll tune the plan once I know your current and target weight.`;
      const followUp = `What does a typical week look like for you - mornings or evenings work better?`;
      return {
        title: 'Your Personalized Program',
        summary,
        followUp,
        metrics: {
          ...(currentWeight ? { 'Current Weight': `${currentWeight} lbs` } : {}),
          ...(goalWeight ? { 'Target Weight': `${goalWeight} lbs` } : {}),
          'Suggested Timeline': `${timeline} weeks`
        },
        recommendations: []
      };
    }
    if (toolId === 'nutrition') {
      const currentWeight = parseFloat(String(safe(context.current_weight) || safe(context.weight) || '').replace(/[^0-9.]/g, '')) || null;
      const protein = currentWeight ? Math.round(currentWeight * 0.8) : null;
      const summary = protein
        ? `Let's keep it simple: aim for ~${protein}g protein today and center carbs around activity. We'll refine portions once I know your schedule.`
        : `Let's keep it simple: protein each meal and carbs around activity. I'll personalize once I know your current weight and schedule.`;
      const followUp = 'Any foods you love or need to avoid?';
      return {
        title: 'Your Nutrition Plan',
        summary,
        followUp,
        metrics: {
          ...(protein ? { 'Daily Protein': `${protein} g` } : {}),
        },
        recommendations: []
      };
    }
  }

  // Generic fallback for any tool
  return {
    title: 'Analysis Ready',
    summary: 'Got it. I will keep this practical and short.',
    followUp: 'What feels like the biggest win if we solved it this week?'
  };
};



